<div [contextMenuTrigger]="menu" [menuContext]="{ value: driverSettlementformsetting, visible: formVisible }" (menuAction)="($event)" class="page">
  <kgrid
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [label]="label"
    [areaName]="areaName"
    [name]="apiName"
    [isMulti]="true"
    [inputEditorform]="inputEditorform"
    [unSortableFilterable]="unSortableFilterable"
    [filters]="filters"
    [isModal]="false"
    [isEdit]="false"
    [isVisible]="true"
    [hasBracketForNegativeValues]="false">
  </kgrid>
</div>
